import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import './LoginBackground.css';

const AuthFormShell = ({
  children,
  maxWidth = 628,
  minHeight = 561,
  height,
  contentTop = 75,
  cardPaddingX = { xs: 2, sm: 4, md: 0 },
}) => {
  const col1Images = [
    '/icons/login/login-bg-1.png',
    '/icons/login/login-bg-2.png',
    '/icons/login/login-bg-3.png'
  ];

  const col2Images = [
    '/icons/login/login-bg-4.png',
    '/icons/login/login-bg-5.png',
    '/icons/login/login-bg-6.png'
  ];

  const col3Images = [
    '/icons/login/login-bg-7.png',
    '/icons/login/login-bg-8.png',
    '/icons/login/login-bg-9.png'
  ];

  const renderColumn = (images, animationClass) => (
    <div className="bg-column-wrapper">
      <div className={`bg-column ${animationClass}`}>
        {images.map((src, idx) => (
          <img key={`orig-${idx}`} src={src} alt="" className="bg-image" />
        ))}
        {images.map((src, idx) => (
          <img key={`dup-${idx}`} src={src} alt="" className="bg-image" />
        ))}
      </div>
    </div>
  );

  const renderFloatingBadge = (className, iconSrc, text, pointerSrc, textColor) => (
    <Box className={`floating-badge ${className}`}>
      <img src={iconSrc} alt="" style={{ width: 24, height: 24 }} />
      <Typography sx={{ color: textColor, fontWeight: 500, ml: 1 }}>{text}</Typography>
      <img className="pointer-icon" src={pointerSrc} alt="" />
    </Box>
  );

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        width: '100vw',
        overflow: 'hidden',
        backgroundColor: '#0f172a',
        boxSizing: 'border-box'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          width: '100%',
          height: '100%',
          zIndex: 0
        }}
      >
        {renderColumn(col1Images, 'scroll-down')}
        {renderColumn(col2Images, 'scroll-up')}
        {renderColumn(col3Images, 'scroll-down')}
      </Box>

      <Box className="login-bg-overlay" sx={{ zIndex: 10 }} />

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          zIndex: 15,
          pointerEvents: 'none'
        }}
      >
        {renderFloatingBadge(
          'badge-track',
          '/icons/login/track-progress.svg',
          'Track Progress',
          '/icons/login/blinkArrow-green.png',
          '#6FC812'
        )}
        {renderFloatingBadge(
          'badge-team',
          '/icons/login/team-collaboration.svg',
          'Team Collaboration',
          '/icons/login/blinkArrow-skyblue.png',
          '#066E82'
        )}
        {renderFloatingBadge(
          'badge-boost',
          '/icons/login/boost-productivity.svg',
          'Boost Productivity',
          '/icons/login/blinkArrow-orange.png',
          '#ED7B1E'
        )}
        {renderFloatingBadge(
          'badge-smart',
          '/icons/login/smart-automation.svg',
          'Smart Automation',
          '/icons/login/blinkArrow-blue.png',
          '#3B82F6'
        )}
      </Box>

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          zIndex: 20
        }}
      >
        <Paper
          elevation={0}
          sx={{
            boxSizing: 'border-box',
            position: 'relative',
            width: '100%',
            maxWidth,
            minHeight: height ?? minHeight,
            height: height ? height : { xs: 'auto', md: minHeight },
            background: '#FAFAFA',
            border: '0.66px solid #5E82D5',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
            borderRadius: '8px',
            overflow: 'hidden',
            px: cardPaddingX,
            pointerEvents: 'auto'
          }}
        >
          <Box
            aria-hidden="true"
            sx={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              width: 458,
              height: 458,
              transform: 'translate(-50%, -50%)',
              pointerEvents: 'none',
              zIndex: 0
            }}
          >
            <Box
              component="img"
              src="/icons/login/logoORKA.gif"
              alt=""
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }}
            />
          </Box>

          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255, 255, 255, 0.43)',
              pointerEvents: 'none',
              zIndex: 0
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              top: 29,
              width: 182,
              height: 41,
              transform: 'translateX(-50%)',
              backgroundImage: "url('/icons/login/orkaflo.png')",
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              pointerEvents: 'none',
              zIndex: 1
            }}
          />

          <Box
            sx={{
              position: 'relative',
              zIndex: 1,
              pt: `${contentTop}px`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            {children}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default AuthFormShell;
